export default [
  {
    path: "payment",
    name: "Pagamentos",
    component: () =>
      import("@/app/modules/payment/pages/payment-action.component.vue"),
    props: true,
  },
  {
    path: "downgrade",
    name: "Downgrade",
    component: () =>
      import("@/app/modules/payment/pages/downgrade-alert.component.vue"),
  },
  {
    path: "transactions/:transaction_id",
    name: "Confirmação de transação",
    component: () =>
      import("@/app/modules/payment/pages/confirm-transaction.component.vue"),
  },
];
